// eslint-disable-next-line import/prefer-default-export
export const setTransactionDates = (props) => {
  const { accountType, endDate, id, startDate } = props;
  return {
    type: 'BT_DEPOSITACCOUNTS_SET_DATES',
    startDate,
    endDate,
    id,
    accountType
  };
};
